// Product descriptions are limited to characteristics documented for the named
// product or line. A model mentioned here is not necessarily stocked by Dropify.
export const BRAND_INTRODUCTIONS: Record<string, { heading: string; paragraphs: string[] }> = {
  'bra-guojisan': {
    heading: 'Mengenal bra Guojisan',
    paragraphs: [
      'Guojisan memiliki bra dengan nomor model yang beragam, termasuk seri GJA, GJB, dan GJC. Salah satu model Guojisan, 7784, menggunakan busa dan kait belakang serta dibuat tanpa kawat.',
      'Guojisan 7784 memiliki cup B dan tiga kait belakang. Bra tanpa kawat seperti model ini dapat digunakan untuk pemakaian sehari-hari.',
    ],
  },
  'camisol-polini': {
    heading: 'Mengenal camisole dan longtorso Polini',
    paragraphs: [
      'Polini memiliki pilihan camisole dan longtorso, yaitu pakaian dalam atasan yang menutup badan lebih panjang daripada bra. Keduanya dapat dipakai sebagai lapisan dalam di bawah pakaian.',
      'Pilihan Polini mencakup seri A3001 sampai A3012 dan model 2388.',
    ],
  },
  'cd-haode': {
    heading: 'Mengenal celana dalam Haode',
    paragraphs: [
      'Haode memiliki celana dalam wanita dan boxer pria. Seri wanita mencakup model berkode CS, sementara boxer memiliki potongan dengan bagian kaki yang lebih panjang.',
      'Pada lini Haode terdapat model wanita bermotif seperti CS06 yang menggunakan bahan stretch.',
    ],
  },
  'cd-lupo': {
    heading: 'Mengenal celana dalam Lupo',
    paragraphs: [
      'Lupo menyediakan celana dalam pria dengan pilihan boxer dan brief. Boxer memiliki bagian kaki lebih panjang, sedangkan brief memiliki bukaan kaki yang lebih tinggi.',
      'Pilihan Lupo mencakup seri Sport, LP, BF, dan model berbahan modal.',
    ],
  },
  'handuk-breitex': {
    heading: 'Mengenal handuk Breitex',
    paragraphs: [
      'Breitex memiliki handuk seri LE dan 1003. Breitex 1003-2 berukuran 80 × 160 cm dan berbobot 500 gram, sedangkan LE-7 berbobot 400 gram. Ukuran 1003-2 dapat digunakan sebagai handuk mandi.',
    ],
  },
  'kaos-kaki-oreo': {
    heading: 'Mengenal kaos kaki bayi dan anak Oreo',
    paragraphs: [
      'Kaos kaki Oreo hadir untuk bayi dan anak dengan pilihan model knee, lurus, boneka, dan 3D. Detail boneka atau 3D memberi bentuk tambahan pada bagian kaos kaki, sedangkan model knee memiliki potongan lebih panjang.',
      'Ada juga model anti slip dengan bagian antiselip pada telapak.',
    ],
  },
  'kaos-kaki-gelea': {
    heading: 'Mengenal kaos kaki Gelea',
    paragraphs: [
      'Gelea menyediakan kaos kaki ankle, yaitu model pendek di sekitar pergelangan kaki. Model G02722 adalah salah satu kaos kaki ankle Gelea.',
      'Pilihannya mencakup desain polos serta motif bunga dan hati, termasuk model berwarna pastel dan model dengan hiasan charm. Potongan pendeknya dapat dipakai dengan sepatu harian.',
    ],
  },
  'kaos-kaki-winteku': {
    heading: 'Mengenal kaos kaki Winteku',
    paragraphs: [
      'Winteku menyediakan kaos kaki bayi dan anak, termasuk model terry, boneka, serta pilihan motif boy dan girl. Pada model boneka, hiasan menjadi bagian dari desain kaos kaki.',
      'Salah satu model kaos kaki bayi Winteku bermotif boy memakai bahan katun dan ditujukan untuk usia 0 sampai 6 bulan.',
    ],
  },
  'sarung-tangan-tuyaya': {
    heading: 'Mengenal sarung tangan Tuyaya',
    paragraphs: [
      'Tuyaya memiliki sarung tangan untuk pria, wanita, dan anak. Pilihannya mencakup model wol serta model touch screen yang ditujukan untuk penggunaan layar sentuh.',
    ],
  },
  'masker-onemed': {
    heading: 'Mengenal masker OneMed KN95',
    paragraphs: [
      'OneMed menyediakan perlengkapan medis, termasuk masker KN95 earloop. Masker ini menggunakan empat lapisan dan tali yang dipasang di telinga. Bentuknya memberi ruang di depan hidung dan mulut.',
      'Masker KN95 OneMed tersedia dalam warna putih, hitam, dan cream. Varian putih dan hitam dikemas 20 pcs per box. Saat dipakai, masker harus menutup hidung dan mulut dengan rapat.',
    ],
  },
  'bra-polini': {
    heading: 'Mengenal bra dan miniset Polini',
    paragraphs: [
      'Polini memiliki lini bra dan miniset. Miniset adalah pakaian dalam atasan yang menutup bagian dada dengan potongan menyerupai atasan pendek; pilihannya mencakup model untuk remaja dan dewasa.',
      'Miniset Polini 682-35 menggunakan katun spandek. Model ini ditujukan untuk remaja dan dewasa.',
    ],
  },
  'cd-hello': {
    heading: 'Mengenal celana dalam Hello',
    paragraphs: [
      'Celana dalam pria Hello tersedia dalam bentuk boxer dan brief. Hello 3105 menggunakan potongan boxer dengan bagian kaki lebih panjang, sedangkan Hello 3106 berbentuk brief dengan bukaan kaki lebih tinggi.',
      'Kedua model memiliki pilihan ukuran L sampai XXXL.',
    ],
  },
  'cd-polini': {
    heading: 'Mengenal celana dalam Polini',
    paragraphs: [
      'Polini memiliki celana dalam wanita dan pria, termasuk model boxer. Untuk wanita, salah satu model Polini adalah CD polos 2828 yang menggunakan katun spandek dan tersedia dalam ukuran M hingga XXL.',
    ],
  },
  'cd-oreo': {
    heading: 'Mengenal celana dalam OREO Ladies',
    paragraphs: [
      'OREO Ladies adalah lini celana dalam wanita dengan berbagai nomor model. Pilihan ukurannya berbeda: model 1239 dan 2276 memiliki rentang M sampai XXL, sementara model 1240 memiliki rentang L sampai XXL.',
      'Model K07, BF7400, dan 1888 dicatat sebagai free size.',
    ],
  },
  'sarung-tangan-lupo': {
    heading: 'Mengenal sarung tangan Lupo',
    paragraphs: [
      'Sarung tangan Lupo tersedia dalam beberapa bentuk dan kegunaan, termasuk model rajut, model anak, serta sarung tangan paskibra. Ada pula seri touch screen dan seri kerja.',
      'Seri touch screen ditujukan untuk penggunaan layar sentuh, sementara sarung tangan paskibra dipakai sebagai bagian dari perlengkapan upacara. Untuk pekerjaan yang membutuhkan perlindungan khusus, periksa dokumen keselamatan pada seri yang digunakan.',
    ],
  },
  'kaos-kaki-tuyaya': {
    heading: 'Mengenal kaos kaki Tuyaya',
    paragraphs: [
      'Tuyaya memiliki kaos kaki untuk beberapa kelompok pemakai dan kegiatan. Pilihannya mencakup kaos kaki pramuka, kaos kaki bola, model sporty dewasa, serta kaos kaki bayi seri BB311.',
      'Model pramuka dipakai sebagai bagian dari seragam, sedangkan model bola dan sporty ditujukan untuk kegiatan olahraga.',
    ],
  },
  'manset-brilles': {
    heading: 'Mengenal manset tangan Brilles',
    paragraphs: [
      'Brilles menyediakan manset tangan dalam model polos, kerut, renda, dan jempol. Manset dipakai pada lengan sebagai pelengkap busana; model jempol memiliki bagian untuk ibu jari.',
      'Seri M212 sampai M218 mencakup beberapa pilihan tersebut. Bentuk ujung, detail kerut atau renda, dan warna membantu membedakan modelnya.',
    ],
  },
}
